"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableToolbar = void 0;
var _dataGrid = require("@ori-ui/data-grid");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../../hooks");
var _models = require("../../../models");
var _FilterButton = require("./FilterButton");
var _jsxRuntime = require("react/jsx-runtime");
const FilterBar = (0, _mui.styled)('div')(()=>({
        display: 'flex',
        alignItems: 'baseline',
        marginRight: 'auto'
    }));
const TableToolbar = exports.TableToolbar = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Toolbar, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FilterBar, {
                "data-testid": getTestId('filter-bar'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        children: formatMessage(_models.TranslationKey.filterOptions)
                    }),
                    Object.keys(_FilterButton.filterTranslationKeyMap).map((filter)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_FilterButton.FilterButton, {
                            dataTestID: getTestId("filter-".concat(filter)),
                            filter: filter
                        }, filter))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_dataGrid.GridToolbar, {})
        ]
    });
});
